import React from 'react';
import { Box } from '@mui/material';
import LoginForm from '../components/auth/LoginForm';

const LoginPage: React.FC = () => {
  return (
    <Box>
      <LoginForm />
    </Box>
  );
};

export default LoginPage;
